import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill-rule="evenodd" clip-rule="evenodd" d="M13.244 16.448a6.792 6.792 0 1 1 2.62-8.687l.422-1.733a.75.75 0 0 1 1.457.355l-.69 2.834a1.583 1.583 0 0 1-1.913 1.163l-2.834-.69a.75.75 0 1 1 .355-1.457l1.982.483a5.292 5.292 0 1 0-2.178 6.451.75.75 0 0 1 .779 1.281Z" fill="currentColor" /> <path d="M9 8.292V11l1.875 1.875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);